import React from "react";
import cns from "classnames";
import { withStyles } from "@material-ui/core";
import Collapse from "../Collapse";
import { SpinnerOverlay } from "../SpinnerOverlay";

import { Classes, ThemeType } from "@theme";

type Props = {
  children?: React.ReactNode;
  classes?: Classes<typeof styles>;
  fitted?: boolean;
  in: boolean;
  isLoading?: boolean;
};

const Collapsible: React.FC<Props> = (props) => {
  const { children, classes, fitted, in: inProp, isLoading } = props;

  return (
    <Collapse
      in={inProp}
      style={{ position: "relative" }}
      className={cns(classes.root, { [classes.padded]: !fitted, visible: inProp })}
      mountOnEnter
      unmountOnExit
    >
      <>
        <SpinnerOverlay show={inProp && isLoading} />
        {children}
      </>
    </Collapse>
  );
};

const styles = (theme: ThemeType) => ({
  root: {
    width: "100%",

    "&.visible": {
      marginBottom: theme.spacing()
    }
  },

  padded: {
    "&.visible": {
      padding: theme.spacing(1 / 2)
    }
  }
});

export default withStyles(styles)(Collapsible);
